import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import { isLoggedInUser } from '../../../utils/isLoggedInUser';
import { MP_CLICKED_CONTACT_ME } from '../../../utils/mixPanelEvents';
import { BQ_CLICKED_CONTACT_SELLER } from '../../../utils/bigQueryEvents';
import { JS_JOIN_HOOK } from '../../../utils/constants';

import './style.scss';

const ContactSellerBtn = (props, {pathfinderWrapper, requestContext, biEvents}) => {

    const onClick = () => {
        biEvents.sendMixPanelEvent({
            eventName: MP_CLICKED_CONTACT_ME,
            params: {'Source component': 'Gig page sticky'}
        });

        biEvents.sendBigQueryEvent({
            eventName: BQ_CLICKED_CONTACT_SELLER,
            params: {name: 'contact_seller'}
        });
    };

    const { username } = requestContext.params;
    const url = pathfinderWrapper.pathfinder('conversation', {id: username});
    const btnClassName = classNames(
        'btn-lrg-standard',
        'btn-white',
        'js-contact-me',
        {[JS_JOIN_HOOK]: !isLoggedInUser(requestContext.current_user)}
    );

    return (
        <div className="contact-seller-btn">
            <a href={url} className={btnClassName} onClick={onClick}>
                <I18n k={'gig_page_perseus.contact_seller.title'}/>
            </a>
        </div>
    );
};

ContactSellerBtn.contextTypes = {
    pathfinderWrapper: PropTypes.object,
    requestContext: PropTypes.object,
    biEvents: PropTypes.object
};

export default ContactSellerBtn;
